import { selectZillClusterNode } from '@newStore/documentUI/transformContent/zillContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const CURRICULUM_ZILL_CLUSTER: BuildingBlockNodeConfig = {
  nodeSelector: selectZillClusterNode,
  information: {
    single: 'Cluster',
    plural: 'Clusters',
  },
  buildingBlocks: [{ type: NodeType.CURRICULUM_ZILL_DEVELOPMENT_FIELD }],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
    },
    descriptionComponent,
  ],
  documentViewIdentifier: 'i',
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default CURRICULUM_ZILL_CLUSTER;
